"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgMicrophoneOff01 = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.707 1.293a1 1 0 0 0-1.414 1.414L8 9.414V12a4 4 0 0 0 6.032 3.446l1.444 1.445A6 6 0 0 1 6 12V9.999a1 1 0 1 0-2 0v2a8.001 8.001 0 0 0 7 7.938V21H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-1.062a7.96 7.96 0 0 0 3.906-1.618l4.387 4.387a1 1 0 0 0 1.414-1.414l-4.387-4.387A7.965 7.965 0 0 0 20 12v-2a1 1 0 1 0-2 0v2c0 1.296-.41 2.496-1.11 3.476l-4.735-4.736-9.448-9.447Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M16 11.757V5a4 4 0 0 0-7.85-1.092l7.85 7.85Z", fill: "currentColor" })] }))); };
exports.default = SvgMicrophoneOff01;
